import React from 'react';
import styles from './bankTile.module.scss';
import ScaledImage from '../app/ScaledImage';
import { IBankDto } from '../../domain/dto/IBankDto';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

interface IProps {
  className?: string;
  data: IBankDto;
  onClick?: () => void;
  to: string;
}

const BankTile: React.FC<IProps> = props => {
  return (
    <Link
      to={props.to}
      className={`w-full h-full max-h-28 ${classNames(styles.bankTile, props.className)}`}
      onClick={props.onClick}
      data-testid="bank-tile"
    >
      {props.data.logoUrl ? (
        <ScaledImage scaleWidth={172} scaleHeight={96} url={props.data.logoUrl} alt={props.data.name} />
      ) : (
        <span className={props.data.name.length > 40 ? styles.longText : styles.shortText}>{props.data.name}</span>
      )}
    </Link>
  );
};

export default BankTile;
